import "@/App.css";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { ProblemSection } from "./components/ProblemSection";
import { PillarsSection } from "./components/PillarsSection";
import { ServicesSection } from "./components/ServicesSection";
import { ValuesSection } from "./components/ValuesSection";
import { CTASection } from "./components/CTASection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <AboutSection />
      <ProblemSection />
      <PillarsSection />
      <ServicesSection />
      <ValuesSection />
      <CTASection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
